import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetRefHistoryOBGyHistoryTypeOfSurgeryDetailByID = (params: any) =>
    GET_ENC(`${BASE_URL}/api/RefHistoryOBGyHistoryTypeOfSurgery/GetDetail?` + params, null);

export const GetRefHistoryOBGyHistoryTypeOfSurgeryList = (params: any) =>
    GET_ENC(`${BASE_URL}/api/RefHistoryOBGyHistoryTypeOfSurgery/GetList?` + params, null);

export const CreateRefHistoryOBGyHistoryTypeOfSurgery = (data: any) =>
    POST_ENC(`${BASE_URL}/api/RefHistoryOBGyHistoryTypeOfSurgery/Create`, data);

export const UpdateRefHistoryOBGyHistoryTypeOfSurgery = (data: any) =>
    POST_ENC(`${BASE_URL}/api/RefHistoryOBGyHistoryTypeOfSurgery/Update`, data);

export const DeleteRefHistoryOBGyHistoryTypeOfSurgery = (data: any) =>
    POST_ENC(`${BASE_URL}/api/RefHistoryOBGyHistoryTypeOfSurgery/Delete`, data);